<template>
	<div id="app">
		<router-view />
	</div>
</template>
<style>
.el-popper {
	left: 0;
	max-width: 100% !important;
	overflow-x: auto !important;
}
</style>
